import { useCallback } from 'react';

import type { TModalProps } from '~components/Modals/types';
import { FeedbackCategory } from '~entities/feedback';
import { useUserId } from '~hooks/useUserId';
import { userApi } from '~services/api/user';
import { ReviewModal } from '~shared/ui/modals';
import type { FeedbackFormValues } from '~shared/ui/organisms';
import { FeedbackForm } from '~shared/ui/organisms';

type Props = TModalProps;

export const ChatReview = ({ open, onClose }: Props) => {
	const userId = useUserId();

	const [send, { isLoading }] = userApi.useSendUserFeedbackMutation();

	const handleSubmit = useCallback(
		async (values: FeedbackFormValues) => {
			const body = {
				category: FeedbackCategory.Chats,
				rate: Number(values.rating),
				text: values.feedback,
			};
			await send({ userId, body });
			onClose();
		},
		[onClose, send, userId]
	);

	return (
		<ReviewModal
			title="Chat Experience Feedback"
			subtitle="Tell us about your satisfaction level with our chat."
			open={open}
			locked={true}
			onClose={onClose}
		>
			<FeedbackForm isLoading={isLoading} onSubmit={handleSubmit} />
		</ReviewModal>
	);
};
